import classNames from "classnames/bind";

import styles from "./ArticleCardTopicList.module.scss";

const cx = classNames.bind(styles);

export const THEMES = ["light", "dark"] as const;

export interface ArticleCardTopicListProps {
    topics: string[];
    theme?: (typeof THEMES)[number];
}

const ArticleCardTopicList = (props: ArticleCardTopicListProps) => {
    const { theme = "light" } = props;

    return (
        <div className={cx("topicsList")}>
            {props.topics.map((topic, i) => (
                <div key={i} className={cx("topic", theme)}>
                    {topic}
                </div>
            ))}
        </div>
    );
};

export default ArticleCardTopicList;
